import DesktopView from "./desktop-view";
import MobileView from "./mobile-view";
import { CarpetSectionProps } from "../types/common";

type DefaultViewProps = {
  data: CarpetSectionProps;
};

export default function DefaultView({ data }: DefaultViewProps) {
  return (
    <>
      <DesktopView data={data} />
      <MobileView data={data} />
    </>
  );
}
